import Raven from 'raven-js';
import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
// @ts-expect-error file is untyped
import addScript from 'documents-ui/lib/addScript';
import GoogleDriveConfig from 'documents-ui/lib/GoogleDriveConfig';
import { GOOGLE_API_LOAD_SUCCEEDED, GOOGLE_AUTHENTICATION_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
import configureGoogleDrive from 'documents-ui/utils/configureGoogleDrive';
const googleLoadedSuccess = createAction(GOOGLE_API_LOAD_SUCCEEDED, identity);
const googleAuthenticationSuccess = createAction(GOOGLE_AUTHENTICATION_SUCCEEDED, identity);
export const loadGoogleApi = () => dispatch => Promise.all([addScript('https://apis.google.com/js/client.js'), addScript('https://accounts.google.com/gsi/client')]).then(() => configureGoogleDrive()).then(({
  isLoaded
}) => {
  if (isLoaded) {
    dispatch(googleLoadedSuccess());
  } else {
    Raven.captureException(new Error('configureGoogleDrive failed to load'));
  }
});
export const getGoogleAuth = () => dispatch => new Promise((resolve, reject) => {
  const GoogleClient = window.google.accounts.oauth2.initTokenClient(Object.assign({
    callback: authResult => {
      if (authResult.error) {
        reject(authResult.error);
        return;
      }
      const authToken = authResult.access_token;
      dispatch(googleAuthenticationSuccess(authToken));
      resolve(authToken);
    }
  }, GoogleDriveConfig().authOptions));
  GoogleClient.requestAccessToken();
});